import React from 'react';

const ClockIcon = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 24C9.62663 24 7.30655 23.2962 5.33316 21.9776C3.35977 20.6591 1.8217 18.7849 0.913451 16.5922C0.00519953 14.3995 -0.232441 11.9867 0.230582 9.65892C0.693604 7.33115 1.83649 5.19295 3.51472 3.51472C5.19295 1.83649 7.33115 0.693604 9.65892 0.230582C11.9867 -0.232441 14.3995 0.00519953 16.5922 0.913451C18.7849 1.8217 20.6591 3.35977 21.9776 5.33316C23.2962 7.30655 24 9.62663 24 12C24 15.1826 22.7357 18.2348 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24ZM12 1.6C9.94308 1.6 7.93234 2.20995 6.22207 3.35272C4.5118 4.49549 3.17881 6.11974 2.39166 8.02009C1.60451 9.92045 1.39855 12.0115 1.79984 14.0289C2.20112 16.0463 3.19163 17.8994 4.64609 19.3539C6.10056 20.8084 7.95366 21.7989 9.97106 22.2002C11.9885 22.6015 14.0796 22.3955 15.9799 21.6083C17.8803 20.8212 19.5045 19.4882 20.6473 17.7779C21.7901 16.0677 22.4 14.0569 22.4 12C22.4 9.24175 21.3043 6.59647 19.3539 4.64609C17.4035 2.69572 14.7583 1.6 12 1.6Z"
				fill="#222222"
			/>
			<path
				d="M15.392 16.528L11.432 12.568C11.3578 12.4932 11.2992 12.4046 11.2594 12.3071C11.2196 12.2096 11.1994 12.1053 11.2 12V5.59998H12.8V11.672L16.528 15.392L15.392 16.528Z"
				fill="#222222"
			/>
		</svg>
	);
};

export default ClockIcon;
